import React from "react";
import { useTranslation } from "react-i18next";
import { GanttFilter, log } from "@planzone/dto";

import { ElementCreationForm, ElementTypes } from "@common/elementCreationForm";
import { QuickElementLoader } from "../quickElementLoader";
import { Props } from "./types";
import styles from "./styles.scss";

function hasValue(value: unknown) {
  return Array.isArray(value) && value.length > 0;
}

function isFiltering({
  scope,
  elementTypes,
  projects,
  ...filter
}: GanttFilter) {
  return !!Object.values(filter).find(hasValue);
}

function Placeholder({ project, filter }: Props) {
  const { t } = useTranslation();

  return isFiltering(filter) ? (
    <p className={styles.placeholder}>
      {t("listsList.placeholder.emptyMatch")}
    </p>
  ) : (
    <ElementCreationForm
      project={project}
      parentList={project.rootList}
      defaultType={ElementTypes.LIST}
      range={{
        min: null,
        max: null,
      }}
      loader={(type, name) => (
        <QuickElementLoader
          type={type}
          name={name}
          parentList={project.rootList}
        />
      )}
    />
  );
}

export { Placeholder };
